import { useRef, useState } from 'react';

import { Icon } from '../../components/Icon';
import { LockedComposerDialog } from './LockedComposerDialog';
import { useCapability } from '../../features/useCapability';
import { useAppStore } from '../state/useAppStore';
import { VISIBLE_APPLICATION_MODES, canTransitionMode } from './applicationModes';

export function ModeNavigation() {
  const currentMode = useAppStore((state) => state.mode);
  const transitionTo = useAppStore((state) => state.transitionTo);
  const canUseComposer = useCapability('composition.workspace');
  const [composerExplanationOpen, setComposerExplanationOpen] = useState(false);
  const composerButtonRef = useRef<HTMLButtonElement | null>(null);

  const closeComposerExplanation = () => {
    setComposerExplanationOpen(false);
    composerButtonRef.current?.focus();
  };

  return (
    <>
      <nav className="mode-navigation" aria-label="Project modes">
        {VISIBLE_APPLICATION_MODES.map((mode) => {
          const isCurrent = mode === currentMode;
          const isComposerLocked = mode === 'composition' && !canUseComposer;
          const isAvailable = canTransitionMode(currentMode, mode);

          return (
            <button
              aria-current={isCurrent ? 'page' : undefined}
              aria-disabled={isComposerLocked || !isAvailable ? true : undefined}
              aria-label={
                isComposerLocked ? 'Composer, available with Placeio Maps Pro' : undefined
              }
              className={[
                'mode-button',
                isCurrent ? 'mode-button-active' : '',
                isComposerLocked ? 'mode-button-locked' : '',
              ]
                .filter(Boolean)
                .join(' ')}
              disabled={!isAvailable && !isComposerLocked}
              key={mode}
              onClick={() => {
                if (isComposerLocked) {
                  setComposerExplanationOpen(true);
                  return;
                }
                transitionTo(mode);
              }}
              ref={mode === 'composition' ? composerButtonRef : undefined}
              type="button"
            >
              {isComposerLocked ? <Icon name="lock" /> : null}
              <span>
                {mode === 'composition' ? 'Composer' : mode.charAt(0).toUpperCase() + mode.slice(1)}
              </span>
            </button>
          );
        })}
      </nav>
      {composerExplanationOpen ? <LockedComposerDialog onClose={closeComposerExplanation} /> : null}
    </>
  );
}
